export const axisVariants = {
  default: {
    code: 'default',
    displayName: 'Default',
    description: 'Standard axis chart with grid lines, axis labels, and default spacing.',
    overrides: {
      props: {},
      className: null,
      styles: {}
    }
  },
  minimal: {
    code: 'minimal',
    displayName: 'Minimal',
    description: 'Clean axis chart with configurable grid lines and margins. Emphasizes the data.',
    parameters: [
      {
        key: 'compactMargins',
        type: 'boolean',
        label: 'Compact Margins',
        default: true
      },
      {
        key: 'showGridLines',
        type: 'boolean',
        label: 'Show Grid Lines',
        default: false
      }
    ],
    resolve: (params) => ({
      props: {},
      className: null,
      tableClassName: null,
      styles: {
        grid: params.compactMargins
          ? { top: '5%', right: '3%', bottom: '5%', left: '3%' }
          : undefined,
        splitLine: params.showGridLines
      }
    })
  }
}
